import englishLanguage from "./languageFiles/englishLanguage";
import polishLanguage from "./languageFiles/polishLanguage";
import swedishLanguage from "./languageFiles/swedishLanguage";
import CommonLanguageHandler from "@payair/e-com-common-sdk/core/LanguageHandler";
/**
 * The format of the keys must be based on ISO format for language (ISO 639-1).
 */
export var translations = {
    en: englishLanguage,
    pl: polishLanguage,
    sv: swedishLanguage,
};
var LanguageHandler = /** @class */ (function () {
    function LanguageHandler(lang) {
        var _this = this;
        this.getString = function (key) { return _this.commonLanguageHandler.getString(key); };
        this.commonLanguageHandler = new CommonLanguageHandler(translations);
        this.commonLanguageHandler.init(lang);
    }
    return LanguageHandler;
}());
export default LanguageHandler;
